export const environment = {
  production: false,
  basePath: '',
  host: '',
  imageUrl: '',
  // CAAS RELATED
  // caasUrl:
  //   'https://partnerwelt-preview.core.prod.aws.tacp.cloud-talanx.com/hdi-prod/d032bce1-0dae-4f9b-857b-70a2aad916e0',
  // caasNavigationUrl:
  //   'https://partnerwelt-preview.core.prod.aws.tacp.cloud-talanx.com/hdi-partnerwelt',
  // caasMedia:
  //   'https://partnerwelt-preview.core.prod.aws.tacp.cloud-talanx.com/media/',
  // preview: true,

  // W1 ohne citrix
  caasUrl:
    'https://caas.first-spirit.shared.prod.panda.tkp.hdi.cloud/hdi-prod/d032bce1-0dae-4f9b-857b-70a2aad916e0',
  caasNavigationUrl:
    'https://caas.first-spirit.shared.prod.panda.tkp.hdi.cloud/hdi-partnerwelt',
  caasMedia:
    'https://partnerwelt-preview.core.prod.aws.tacp.cloud-talanx.com/media/',
  preview: true,

  // will delete later
  navigationToken: 'c7b3b6fa-c1f4-4ecf-93d0-c91ad1a3c535',
  releaseToken: '3b79cb4c-485c-4feb-87d4-720c94170c44',
  previewToken: 'c5030071-bd8c-44e0-8771-e83dbf57be94',
};
